import { useState } from 'react';
import isConsentGranted, { hasOneTrustLoaded } from 'utils/consent-check';

const useConsentCheck = (consentCode) => {
  const [isConsentSet, setIsConsentSet] = useState(false);
  const [isGranted, setIsGranted] = useState(false);

  const checkIfConsentIsGranted = () => {
    if (hasOneTrustLoaded()) {
      setIsGranted(isConsentGranted(consentCode));
      setIsConsentSet(true);
    }
  };

  const intervalId = setInterval(() => {
    checkIfConsentIsGranted();
    if (isConsentSet) {
      clearInterval(intervalId);
    }
  });

  return isGranted;
};

export default useConsentCheck;
